export const getWaitTimeSeconds = (
	maxWaitSeconds?: number,
	waitSeconds?: number,
): number => maxWaitSeconds ?? waitSeconds ?? 0;
